module.exports = __webpack_public_path__ + "img/imepg.86587ea1.jpeg";